export function isMobile() {
  return document.body.clientWidth < 768;
}
